import {determineOpCo} from '../../Utils/Utils';

export async function startSession(
  opcoId: string
) {
  try {
    let URI = "";
    URI = `${process.env.REACT_APP_BASE_URL}`;

    const headers = {
      'opCo': determineOpCo(opcoId)
    }

    const response = await fetch(URI, {
      headers: headers,
      method: "GET",
    });

    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      if (responseData.status.statusCode === 200) {
        return responseData;
      } else {
        throw new Error("'startSession' failed");
      }
    } else {
      throw new Error("'startSession' failed");
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}
